import {connect} from 'react-redux';
import {TransilluminatorControls as Component} from './TransilluminatorControls';
import {
  showModal,
  setGelInTransilluminator,
  turnOnTransilluminator,
  transilluminatorGelExmined,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    open: state.notebook.protocolSection.scene.apparatus.transilluminator[0].open,
    on: state.notebook.protocolSection.scene.apparatus.transilluminator[0].on,
    containsGel: state.notebook.protocolSection.scene.apparatus.transilluminator[0].containsGel,
    gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[0].gelExamined,
    display:  state.notebook.protocolSection.scene.modal.display,
    notebookExpanded: !state.notebook.notebookCollapsed,
    agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel,
    level: state.notebook.levelSelected.id,
    gelOrientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[0].gelOrientation
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) =>{
      dispatch(showModal(data))
    },

    setGelInTransilluminator: (data) => {
      dispatch(setGelInTransilluminator(data))
    },
    turnOnTransilluminator: (data) => {
      dispatch(turnOnTransilluminator(data))
    },
    transilluminatorGelExmined: (data) => {
      dispatch(transilluminatorGelExmined(data))
    },
  }
}

export const TransilluminatorControls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
